<template>
  <div class="container">
    <el-table id="table" :data="curProcedure" class="table-border" v-loading="loading"
              header-cell-class-name="table-head">
      <el-table-column label="工序名称">
        <template #default="{row}">
          <div class="handler">{{row.name}}</div>
        </template>
      </el-table-column>
      <el-table-column label="工序类型">
        <template #default="{row}">
          <div class="handler" v-loading="$isEmpty(procedureTypeMap)">{{procedureTypeMap[row.type]}}</div>
        </template>
      </el-table-column>
      <el-table-column label="状态" width="60">
        <template #default="{row}">
          <div class="handler">{{row.status | status}}</div>
        </template>
      </el-table-column>

      <el-table-column :width="deletable ? 70 : 80" align="center" fixed="right">
        <template #header>
          <el-button v-if="addable && !deletable" icon="el-icon-plus" type="primary" @click="add"></el-button>
        </template>
        <template #default="{row}">
          <el-button type="text" @click="edit(row)" size="mini">{{readOnly ? '查看' : '编辑'}}</el-button>
        </template>
      </el-table-column>
      <el-table-column :width="deletable ? 80: 1" align="center" fixed="right">
        <template #header>
          <el-button v-if="addable && deletable" icon="el-icon-plus" type="primary" @click="add"></el-button>
        </template>
        <template #default="{row}">
          <el-button type="text" size="mini" @click="deleteProcedure(row)" class="danger">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div v-show="isSorting" style="margin-top: 10px; text-align: center">
      <el-button type="primary" @click="confirmSort">确定排序</el-button>
      <el-button @click="cancelSort">取消排序</el-button>
    </div>

    <edit-procedure-dialog :visible.sync="dialog.show"
                           :procedure-id="dialog.procedureId"
                           :read-only="readOnly">
    </edit-procedure-dialog>
  </div>
</template>

<script>
  import Sortable from 'sortablejs'
  import $ from 'jquery'
  import EditProcedureDialog from '@/views/procedure/EditProcedureDialog'
  import { shareDataMixin } from '@/views/mixins/ShareData'
  import authority from '@/utils/authority'

  export default {
    name: 'ProcedureList',
    components: { EditProcedureDialog },
    mixins: [shareDataMixin],
    data () {
      return {
        loading: false,
        sortingProcedure: null,
        dialog: {
          show: false,
          procedureId: null
        }
      }
    },
    created () {
      this.loading = true
      this.$store.dispatch('procedure/middleProcedureList').finally(() => {
        this.loading = false
      })
    },
    mounted () {
      Sortable.create(document.querySelector('#table tbody'), {
        handle: '.handler',
        // 最后一个是质检不支持排序
        draggable: 'tr:nth-last-child(n + 2)',
        onEnd: ({ newIndex, oldIndex }) => {
          if (newIndex === oldIndex) return

          if (this.sortingProcedure === null) {
            this.sortingProcedure = this.$_.cloneDeep(this.procedures)
          }

          const children = $('#table tbody').children()
          const curRow = children.eq(newIndex)
          if (oldIndex === children.length - 1) {
            children.eq(children.length - 1).after(curRow)
          } else if (oldIndex === 0) {
            children.eq(0).before(curRow)
          } else if (newIndex < oldIndex) {
            children.eq(oldIndex + 1).before(curRow)
          } else {
            children.eq(oldIndex - 1).after(curRow)
          }

          if (this.sortingProcedure[oldIndex].type === 'QUALITY') {
            this.sortingProcedure = null
          } else {
            const cur = this.sortingProcedure.splice(oldIndex, 1)[0]
            this.sortingProcedure.splice(newIndex, 0, cur)
          }
        }
      })
    },
    methods: {
      confirmSort () {
        this.$store.dispatch('procedure/update', this.sortingProcedure).then(() => {
          this.sortingProcedure = null
          this.$message.success('排序更新成功!')
        })
      },
      cancelSort () {
        this.sortingProcedure = null
        this.$message.info('排序更新已取消')
      },
      add () {
        this.dialog.procedureId = null
        this.dialog.show = true
      },
      edit (procedure) {
        this.dialog.procedureId = procedure.id
        this.dialog.show = true
      },
      deleteProcedure (procedure) {
        this.$confirm(`确认删工序【${procedure.name}】, 是否继续?`, '提示', {
          confirmButtonText: '删除',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$store.dispatch('procedure/delete', procedure.id).then(() => {
            this.$message.success('删除成功!')
          })
        }).catch(() => {
        })
      }
    },
    computed: {
      isSorting () {
        return !!this.sortingProcedure
      },
      procedures () {
        return this.$store.state.procedure.middleProcedureList
      },
      curProcedure () {
        return this.sortingProcedure || this.procedures
      },
      readOnly () {
        return !this.$hasPermission(authority.EDIT_PROCEDURE)
      },
      addable () {
        return this.$hasPermission(authority.ADD_PROCEDURE)
      },
      deletable () {
        return this.$hasPermission(authority.DELETE_PROCEDURE)
      }
    },
    beforeRouteLeave (to, from, next) {
      // 路由离开之前取消排序
      this.sortingProcedure = null
      next()
    }
  }
</script>

<style lang="scss" scoped>
  .handler {
    cursor: pointer;
  }

  /deep/ {
    tr:nth-last-child(n + 2) .handle {
      cursor: pointer;
    }

    th {
      height: 50px;
    }
  }
</style>
